import { styled } from '@mui/material';
import React, { type ComponentProps } from 'react';

const Root = styled('div', {
  shouldForwardProp: (prop) => !['variant'].includes(prop as string),
})<{ variant?: 'white' | 'blue' }>(({ theme }) => ({
  variants: [
    {
      props: { variant: 'blue' },
      style: { backgroundColor: theme.palette.background.default },
    },
  ],
}));

const Container = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '1680px',
  padding: '60px 26px',
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('md')]: {
    padding: '90px 48px',
  },
  [theme.breakpoints.up('lg')]: {
    padding: '100px 64px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: '120px 90px',
  },
}));

export type SectionProps = ComponentProps<typeof Root>;

export const Section: React.FC<SectionProps> = ({ children, variant, ...props }) => {
  return (
    <Root variant={variant}>
      <Container {...props}>{children}</Container>
    </Root>
  );
};
